import {InjectionToken} from "@angular/core";

export const WIZARD_DATA = new InjectionToken<any>('data');
